import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BottomScroll from "./BottomScroll";
import { toast } from "react-toastify";
import { SET_ONBOARDING_GOAL } from "../../redux/actions/types";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";

const StepThree = ({ setStep }) => {
  const firstName = useSelector((store) => store?.profileDetails?.first_name);
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const goal = useSelector((store) => store?.onBoarding?.goal) || "";

  useEffect(() => {
    if(inputRef.current){
      inputRef.current.focus();
    }
  }, [inputRef]);


  const handleContinue = () => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_THIRD_STEP_CONTINUE_BUTTON_CLICKED);
    if(goal?.length > 0){
      setStep(4);
      return;
    }
    toast.error("Please enter a job role");

  }

  const handleSetGoal = (goal) => {
    dispatch({type: SET_ONBOARDING_GOAL, payload: goal});
  }

  useEffect(() => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_THIRD_STEP_LOADED);
  }, []);

  return (
    <div className="flex h-[60dvh] relative  flex-col items-center justify-center">
      <div className="pr-4 text-[24px] leading-[125%] text-white">
        Perfect {firstName}! Let’s Personalise the Experience To{" "}
        <span className="font-bold"> Get You Hired </span> As A{" "}
      </div>
      <div className="mt-8 flex w-full flex-col items-center justify-center">
        <input
          onChange={(e) => {handleSetGoal(e.target.value)}}
          value={goal}
          required
          placeholder="For e.g. Data Scientist, Software Dev, etc."
          disabled={false}
          className={`h-12 w-full appearance-none rounded-lg border-2 border-transparent bg-[#07274b] px-3   
                                    text-white placeholder:text-sm placeholder:font-normal placeholder:text-white/50 focus:z-10 focus:border-[#7FC241] focus:outline-none focus:border-2 focus:ring-0 disabled:bg-[#475a73] sm:text-sm`}
          ref={inputRef}
        />
        <button className="mt-4 h-12 w-full rounded-lg  bg-[#7FC241] text-center text-[16px] font-semibold text-[18px] text-[#121212] disabled:opacity-50" disabled={goal?.length === 0} onClick={handleContinue}>
          Continue
        </button>
      </div>
    
    </div>
  );
};

export default StepThree;
